import { cn } from '@/lib/utils';
import type { RatingDistribution } from '@/types/feed';
import { Pressable, Text, View } from 'react-native';

const RATING_ROWS = [
  { key: 'must_try', label: 'Must Try', field: 'mustTry' as const },
  { key: 'try_it', label: 'Try It', field: 'tryIt' as const },
  { key: 'okay', label: 'Okay', field: 'okay' as const },
  { key: 'not_for_me', label: 'Skip It', field: 'notForMe' as const },
] as const;

interface RatingDistributionChartProps {
  distribution: RatingDistribution;
  selectedRatingKey?: string;
  onBarPress: (key: string) => void;
}

export function RatingDistributionChart({
  distribution,
  selectedRatingKey,
  onBarPress,
}: RatingDistributionChartProps) {
  const maxCount = Math.max(
    distribution.mustTry,
    distribution.tryIt,
    distribution.okay,
    distribution.notForMe,
    1
  );

  return (
    <View className="px-4 py-3" style={{ gap: 8 }}>
      {RATING_ROWS.map((row) => {
        const count = distribution[row.field];
        const barFraction = count / maxCount;
        const isSelected = selectedRatingKey === row.key;
        const hasSelection = !!selectedRatingKey;

        return (
          <Pressable
            key={row.key}
            onPress={() => onBarPress(row.key)}
            className="flex-row items-center"
            style={{ gap: 8 }}
          >
            <Text
              className="text-sm text-foreground"
              style={{ width: 60 }}
              numberOfLines={1}
            >
              {row.label}
            </Text>
            <View className="flex-1 h-6 rounded bg-surface-secondary overflow-hidden">
              <View
                className={cn(
                  'h-full rounded',
                  hasSelection
                    ? isSelected
                      ? 'bg-primary'
                      : 'bg-primary/30'
                    : 'bg-primary'
                )}
                style={{ width: `${Math.max(barFraction * 100, count > 0 ? 4 : 0)}%` }}
              />
            </View>
            <Text
              className="text-sm text-muted-foreground"
              style={{ width: 32, textAlign: 'right' }}
            >
              {count}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}
